module.exports = __webpack_public_path__ + "fonts/gothic-a1-v8-latin-700.a7cd0ec8.woff2";